export default __webpack_public_path__ + "static/news-roundabout-576aaa4397efdc910a69735f3989fe00.jpg";